import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=2089b860&scoped=true&"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetail.vue?vue&type=style&index=0&id=2089b860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089b860",
  null
  
)

export default component.exports